var exports = {
  "kL": "xfd349460--507c1c--container",
  "zk": "xfd349460--507c1c--present-info",
  "my": "xfd349460--507c1c--avatar",
  "DD": "xfd349460--507c1c--title",
  "Gx": "xfd349460--507c1c--listing-link",
  "ne": "xfd349460--507c1c--controls",
};

module.exports = exports;
